import api from '@/api'

const getOrders = async () => {
  const result = await api.get('/api/order/my_order')
  
  return result
}

const getOrderById = async (orderId) => {
  let result = null
  try {
    let address = JSON.parse(localStorage.getItem('userAddress'))
    const phone = address?.[0]?.phone
    const query = phone ? `?user=${encodeURIComponent(phone)}` : ''
    result = await api.get(`/api/order/${orderId}${query}`)
  } catch (err) {
    result = await api.get(`/api/order/${orderId}`)
  }
  
  return result
}

const getOrderStatus = async (orderId) => {
  let result = null
  try{
    let address = JSON.parse(localStorage.getItem('userAddress'))
    result = await api.post('/api/order/ping_payment_status', { order_id: orderId, user: address[0].phone })
  }catch(err){
    result = await api.post('/api/order/ping_payment_status', { order_id: orderId, user: "" })
  }
  
  return result
}

const saveLog = async (request) => {
  const result = await api.post(`/api/order/save_log`, request, { loading: false })
  return result
}

const getPaymentDetailById = async (orderId) => {
  let result = null
  try{
    let address = JSON.parse(localStorage.getItem('userAddress'))
    result = await api.post('/api/order/payment_detail', { order_id: orderId, user: address[0].phone })
  }catch(err){
    result = await api.post('/api/order/payment_detail', { order_id: orderId, user: "" })
  }
  
  return result
}

const downloadQrCode = async (orderId) => {
  let result = null
  try {
    let address = JSON.parse(localStorage.getItem('userAddress'))
    const phone = address?.[0]?.phone
    const query = phone ? `?user=${encodeURIComponent(phone)}` : ''
    result = await api.get(`/api/order/download_qrcode/${orderId}${query}`, { responseType: "arraybuffer" })
  } catch (err) {
    result = await api.get(`/api/order/download_qrcode/${orderId}`, { responseType: "arraybuffer" })
  }
  
  return result
}

const getCancelReasonList = async () => {
  const result = await api.get('/api/order/cancellation_reason_list')
  return result
}

const cancelOrder = async (orderId, reason) => {
  const result = await api.post('/api/order/cancel_order', {
    order_id: orderId,
    reasons: [
      reason
    ]
  })
  return result
}

// FIX TASK 2: Guest cancellation — no JWT required, verified by phone + order_id
const cancelOrderGuest = async (orderId, reason, phone) => {
  const result = await api.post('/api/order/cancel_order_guest', {
    order_id: orderId,
    user: phone,
    reasons: [reason]
  }, { noRequiredToken: true })
  return result
}

export default {
  getOrders,
  cancelOrder,
  cancelOrderGuest,
  getOrderById,
  downloadQrCode,
  getOrderStatus,
  getCancelReasonList,
  getPaymentDetailById,
  saveLog
}
